import { atom } from 'jotai';
import type { BrowserRouterProps } from 'react-router-dom';

export const leaveRouteConfirmationState = atom<BrowserRouterProps['getUserConfirmation'] | null>(null);
